import { render, staticRenderFns } from "./AllocateQuantityModal.vue?vue&type=template&id=4161c329&scoped=true"
import script from "./AllocateQuantityModal.vue?vue&type=script&lang=js"
export * from "./AllocateQuantityModal.vue?vue&type=script&lang=js"
import style0 from "./AllocateQuantityModal.vue?vue&type=style&index=0&id=4161c329&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4161c329",
  null
  
)

export default component.exports